import {
  ChangeDetectionStrategy,
  Component,
  output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectItem } from '@web/shared/ui';
import { Nillable, valueOrDefault } from '@web/utils';
import { Observable } from 'rxjs';
import {
  PublicBrandCosmeticSortType,
  PublicBrandCosmeticSortTypeSelectItemsProviderService,
} from '@web/shared/module/brand';
import { PublicSortPanelComponent } from '../public-sort-panel/public-sort-panel.component';

@Component({
  selector: 'app-public-brand-cosmetic-sort-panel',
  imports: [CommonModule, PublicSortPanelComponent],
  templateUrl: './public-brand-cosmetic-sort-panel.component.html',
  styleUrl: './public-brand-cosmetic-sort-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandCosmeticSortPanelComponent {
  /* prettier-ignore */
  private readonly provider = inject(PublicBrandCosmeticSortTypeSelectItemsProviderService);

  /* prettier-ignore */
  public readonly sortTypeChange = output<Nillable<PublicBrandCosmeticSortType>>();

  protected readonly selectItems$ = this.selectItemsSource();
  protected readonly valueOrDefault = valueOrDefault;

  /* prettier-ignore */
  private selectItemsSource(): Observable<SelectItem<PublicBrandCosmeticSortType>[]> {
    return this.provider.selectItems();
  }
}
